<template>
    <div id="app">
        <Header></Header>
        <router-view />
    </div>
</template>

<script>
import Header from './components/Header.vue'

export default {
    name: 'App',
    components: {
        Header
    }
}
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Montserrat:400,700,900&display=swap');

@mixin fontBlack {
    font-family: 'Montserrat', sans-serif;
    font-weight: 900;
    font-style: normal;
}

@mixin fontBold {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-style: normal;
}

@mixin fontMain {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-style: normal;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
